<div class="sv-page-login">
  <div class="sv-page-login-content-area overflow-y-scroll">
    <div class="sv-page-login-content-area__header">
      <div class="sv-page-login-logo-accessory">
        <a class="sv-page-login-logo-wrapper" href="javascript:void(0)">
          <img src="{{environment.appMetadata.main.logo}}" class="sv-page-login-logo" />
        </a>
        <!-- <div class="sv-page-login-logo-accessory__title">{{environment.appMetadata.main.owner}}</div> -->
        <div class="sv-page-login-logo-accessory__slogan">{{environment.appMetadata.main.title}}</div>
      </div>
    </div>
    <div class="sv-page-login-content-area__body">
      <router-outlet></router-outlet>
    </div>

    <div class="sv-page-login-content-area__footer">
      <div>
        <div class="sv-page-login-logo-accessory__title text-center">{{environment.appMetadata.main.owner}}</div>
        <div>Địa chỉ: <b>{{environment.appMetadata.main.address}}</b></div>
        <div>Hotline: <b>{{environment.appMetadata.main.hotline}}</b></div>
      </div>
    </div>
  </div>
</div>
<p-toast class="sv-toast" position="bottom-right" key="success-warn"></p-toast>